import { createButton } from 'react-simple-wysiwyg';

import { TypeStrikethrough01Icon } from '@/assets/icons/TypeStrikethrough01Icon';

export default createButton('Clear Formatting', <TypeStrikethrough01Icon />, 'removeFormat');
